let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("7K0J5")), load("kqQjY")]).then(() => parcelRequire('8FiQk'));